/**
 * Разбор ответа GET `/inventory/group/:gid/object-types/:id` (после axios-интерцептора).
 *
 * @param res сырой ответ запроса
 * @returns `{ id, title }` либо `null`, если данные невалидны
 */
export function parseObjectTypeDetailResponse(res: unknown): { id: number; title: string } | null {
  const row = (res as { data?: unknown })?.data
  if (!row || typeof row !== 'object') return null
  const rec = row as Record<string, unknown>
  const id = Number(rec.id)
  if (!Number.isFinite(id)) return null
  const title =
    (typeof rec.name === 'string' && rec.name) ||
    (typeof rec.object_name === 'string' && rec.object_name) ||
    ''
  return { id, title: title || String(id) }
}
